import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import styles from "./Login.module.css";

import { Button, Checkbox, Form, Input, Modal, notification } from "antd";
import { AppContext } from "../App.context";
import axios from "axios";
import {
  checkAuth,
  checkEmpty,
  getAboutLot,
  getCheckHeveGetNew,
  getToken,
  getUserMe,
  isAdmin,
  pathRoutes,
  saveToken,
  setToken,
} from "../service/util.service";
import {
  useLocation,
  useNavigate,
  useNavigation,
  useSearchParams,
} from "react-router-dom";
import LoadingCenterSpinSmall from "../main/LoadingCenterSpinSmall";
import { WarningOutlined } from "@ant-design/icons";

function Login(props) {
  const navigate = useNavigate();
  const appContext = useContext(AppContext);

  const [searchParams, setSearchParams] = useSearchParams();

  const [loadingLogin, setLoadingLogin] = useState(false);
  const [loadingCache, setLoadingCache] = useState(false);
  const [sessionModal, setSessionModal] = useState(false);
  const [isError, setIsError] = useState(false);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [nickname, setNickname] = useState("");

  const loadData = async () => {
    let havegetnew = await getCheckHeveGetNew();

    if (!checkEmpty(localStorage.getItem("aboutLot")) && havegetnew == false) {
    } else {
      try {
        let aboutLot = await getAboutLot();
        localStorage.setItem("aboutLot", JSON.stringify(aboutLot));
        console.log("aboutLot", aboutLot);
      } catch (e) {}
    }
  };

  useEffect(() => {
    appContext.setAcUsername(null);
    loadData();
  }, []);

  const loginApi = (username, password, nickname) => {
    setLoadingLogin(true);
    setIsError(false);
    let config = {
      headers: {
        "Content-Type": "application/json",
        // Authorization: getAuthorization(),
      },
    };
    let link = process.env.REACT_APP_SERVICE_URL + "/v1/login";
    console.log("link:", link);
    const data = {
      username: username,
      password: password,
      nickname: nickname,
    };
    axios
      .post(link, data, config)
      .then((res) => {
        console.log(res?.data?.token);
        if (!checkEmpty(res.data.token)) {
          setLoadingLogin(false);
          // setToken(res.data.token);
          saveToken(res.data);
          appContext.setTokenMain(res.data.token);
          if (isAdmin()) {
            navigate(pathRoutes.selectUser);
            // window.location.href =
            // window.location.href + "" + pathRoutes.selectUser;
          } else {
            navigate(pathRoutes.main);
            // window.location.href = window.location.href + "" + pathRoutes.main;
          }
        } else {
          // api["error"]({
          //   message: "เข้าระบบ",
          //   description: "เข้าระบบผิดพลาด",
          // });
          setIsError(true);
        }
      })
      .catch(function (error) {
        // api["error"]({
        //   message: "เข้าระบบ",
        //   description: "เข้าระบบผิดพลาด",
        // });
        setIsError(true);
      })
      .finally(function () {
        // always executed
        setLoadingLogin(false);
      });
  };
  const checkUser = async () => {
    if (!checkEmpty(getToken())) {
      if (isAdmin()) {
        navigate(pathRoutes.selectUser);
      } else {
        navigate(pathRoutes.main);
      }
    }
  };

  const warning = () => {
    Modal.warning({
      title: "Session",
      content: "Session หมดอายุ",
      afterClose: () => {
        // appContext.setModalSession(false);
        // logout();
        setSessionModal(true);
      },
    });
  };
  const location = useLocation();
  useEffect(() => {
    checkUser();

    let session = searchParams.get("session");

    if (session == "false") {
      if (sessionModal == false) {
        setSessionModal(true);
      }
    }
  }, []);

  const onFinish = (values) => {
    console.log("Success:", values);
    loginApi(values.username, values.password, values.nickname);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const [api, contextHolder] = notification.useNotification();

  const handleUsername = (event) => {
    event.preventDefault();
    setUsername(event.target.value);
  };

  const handlePassword = (event) => {
    event.preventDefault();
    setPassword(event.target.value);
  };
  const handleNickname = (event) => {
    event.preventDefault();
    setNickname(event.target.value);
  };
  const onClickLogin = () => {
    if (loadingLogin) return;
    if (checkEmpty(username) || checkEmpty(password) || checkEmpty(nickname)) {
      setIsError(true);
      return;
    }
    loginApi(username, password, nickname);
  };

  return (
    <div className={styles.boxLogin}>
      <h1 className={styles.boxHeader}>Login</h1>
      <div>
        <div
          style={{
            display: "flex",
            width: "100%",
            marginBottom: "5px",
            paddingBottom: "10px",
          }}
        >
          <div style={{ width: "100%", fontSize: "1rem" }}>Username</div>
        </div>
        <Input
          autocomplete="off"
          className={styles.inputBox}
          placeholder={"Username"}
          value={username}
          onChange={handleUsername}
        />

        <div
          style={{
            marginTop: "15px",
            alignSelf: "flex-start",
            fontSize: "1rem",
            paddingBottom: "10px",
          }}
        >
          {"Password"}
        </div>
        <Input.Password
          autocomplete="off"
          className={styles.inputBoxPassword}
          placeholder={"Password"}
          value={password}
          onChange={handlePassword}
          // classNames={styles.txtPassword}
        />
        <div
          style={{
            marginTop: "15px",
            alignSelf: "flex-start",
            fontSize: "1rem",
            paddingBottom: "10px",
          }}
        >
          {"Nickname"}
        </div>

        <Input
          autocomplete="off"
          className={styles.inputBox}
          placeholder={"Nickname"}
          value={nickname}
          onChange={handleNickname}
        />

        {isError && (
          <div className={styles.texterr}>
            Invalid username or password or nickname
          </div>
        )}

        <div
          style={{
            textAlign: "center",
            marginTop: "40px",
            marginBottom: "24px",
          }}
        >
          <Button
            // className={`${className ? className : !ghost && styles.CenterBtn}`}

            loading={loadingLogin}
            type={"primary"}
            // ghost={ghost}
            shape={"round"}
            size={"large"}
            onClick={onClickLogin}
          >
            Login
          </Button>
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: "40px",
            marginBottom: "24px",
          }}
        >
          <Button
            // className={`${className ? className : !ghost && styles.CenterBtn}`}

            loading={loadingCache}
            type={"default"}
            // ghost={ghost}
            shape={"round"}
            size={"large"}
            onClick={() => {
              setLoadingCache(true);
              localStorage.clear();
              setTimeout(() => {
                setLoadingCache(false);
              }, 1000);
            }}
          >
            Clear Cache
          </Button>
        </div>
        {/* <Form
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          style={{ maxWidth: 600 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            className={styles.boxInput}
            label="Username"
            name="username"
            rules={[{ required: true, message: "Please input your username!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password />
            {/* <Input className={styles.txtPassword} /> */}
        {/* </Form.Item>
          <Form.Item
            className={styles.boxInput}
            label="Nickname"
            name="nickname"
            rules={[{ required: true, message: "Please input your nickname!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button type="primary" htmlType="submit">
              {loadingLogin ? <LoadingCenterSpinSmall /> : "Submit"}
            </Button>
          </Form.Item>
          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <Button
              type="default"
              onClick={() => {
                localStorage.clear();
              }}
            >
              Clear Cache
            </Button>
          </Form.Item> */}
        {/* </Form> */}
      </div>

      <Modal
        title="Session"
        open={sessionModal}
        onOk={() => {
          setSessionModal(false);
        }}
        closable={false}
        footer={[
          <Button
            key="OK"
            type="primary"
            onClick={() => {
              setSessionModal(false);
              navigate(pathRoutes.login);
            }}
          >
            OK
          </Button>,
        ]}
      >
        <div style={{ display: "flex" }}>
          <WarningOutlined
            style={{ color: "orange", fontSize: "22px", alignSelf: "center" }}
          />
          <p style={{ paddingLeft: "10px" }}>Session หมดอายุ</p>
        </div>
      </Modal>
      {contextHolder}
    </div>
  );
}
export default Login;
